/** @format */

import React, { Component } from 'react';
import { Segment, Header, Grid, Divider } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import MostRequestParts from './MostRequestParts';
import MostRequestPartsCars from './MostRequestPartsCars';
import MostSoldParts from './MostSoldParts';
import MostSoldPartsCars from './MostSoldPartsCars';

@observer
class StatsOverview extends Component {
  render() {
    return (
      <Grid columns="2">
        <Grid.Row>
          <Grid.Column>
            <Segment>
              <Header as="h3" children="Ricambi più richiesti" />
              <Divider />
              <MostRequestParts />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment>
              <Header as="h3" children="Ricambi più venduti" />
              <Divider />
              <MostSoldParts />
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Segment>
              <Header as="h3" children="Auto/Ricambio più richiesti" />
              <Divider />
              <MostRequestPartsCars />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment>
              <Header as="h3" children="Auto/Ricambio più venduti" />
              <Divider />
              <MostSoldPartsCars />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default StatsOverview;
